import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionProps {
  emoji: string;
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  previewImage?: string;
}
export function Accordion({
  emoji,
  title,
  children,
  defaultOpen = false,
  previewImage
}: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return <div className="overflow-hidden rounded-xl border border-white/10 bg-[#111]/90" data-id="element-16">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="w-full text-left" data-id="element-17">
        {previewImage && <div className="border-b border-white/10 bg-black/30 p-2.5" data-id="element-18">
            <img src={previewImage} alt="" className="h-28 w-full rounded-lg border border-white/10 object-cover object-top" data-id="element-19" />
          </div>}
        <div className="flex items-center gap-3 px-4 py-4" data-id="element-20">
          <span className="text-xl leading-none" aria-hidden="true" data-id="element-21">
            {emoji}
          </span>
          <span className="flex-1 font-oswald text-[15px] font-600 leading-tight text-white" data-id="element-22">
            {title}
          </span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[#F5C518] transition-transform duration-300 ${open ? 'rotate-180' : ''}`} data-id="element-23" />
        </div>
      </button>
      <AnimatePresence initial={false} data-id="element-24">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-25">
            <div className="border-t border-white/10 px-4 py-4" data-id="element-26">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}